import React from 'react';

const defaultContext = {
  principal: {},
  imUserRespVO: {},
  agentList: [],
  memberInfo: {},
  memberIsWhite: false,
  updatePrincipal: () => {},
  updateImInfo: () => {},
  updateMemberInfo: () => {},
  updateCustomerList: () => {},
  cartCount: 0, // 废弃
  updateCartCount: () => {}, // 废弃
  webImNum: 0, //环信消息数量
  updatehWebImNum: () => {},
  updateImMsgCnt: () => {},
  logout: () => {},
  basicConfig: {},
  updateBasicConfig: () => {},
  permission: {}, // 客户权限信息
  updatePermission: () => {},
  history: () => {},
  updateMenus: () => {},
  topMenuList: [], // 顶部菜单
  middleMenuList: [], // 中部菜单
  isSpecialUser: false,
  permCart: {}, // 购物车
  profile: {}, //个人中心
  days: [], //有货提醒和备货提醒天数
  updateDays: () => {},
  orderTypeList: [], //订单类型(定制或者常备等)
  updateOrderType: () => {},
  updateSignStatus: () => {},
  updateMemberisBlock: () => {},
};

export default React.createContext(defaultContext);
